import React from 'react'
import { t } from '@lingui/macro'
import { Spinner } from '../../../components'
import { HeadTitle } from '../../../components/common/head/HeadTitle'
import { useSignupSecretLinkQuery } from './SelfSignupWithSecretLink.codegen'
import { PageWithSingleAlert } from '../../PageWithSingleAlert'
import { WithSelfSignupFormik } from '../self-signup/WithSelfSignupFormik'
import { SelfSignUpForm } from '../self-signup/SelfSignUpForm'
import { WithSelfSignupContext } from '../self-signup/SelfSignupContext'
import { SignupWithSecretLinkController } from './SignupWithSecretLinkController'
import { useLoginContext } from '../login/LoginContext'
import { observer } from 'mobx-react'
import {
  SelfSignupFormFieldsContext,
  SelfSignupFormFieldsContextType
} from '../self-signup/SelfSignupFormFieldsContext'

type SelfSignupWithSecretLinkProps = {
  submit(): Promise<boolean>
  fieldsContext: SelfSignupFormFieldsContextType
}

export const SelfSignupWithSecretLink: React.FC<SelfSignupWithSecretLinkProps> =
  observer(({ fieldsContext, submit }) => {
    const { selfSignupToken } = useLoginContext()

    const { data: secretLinkData, loading } = useSignupSecretLinkQuery({
      variables: {
        token: selfSignupToken
      },
      skip: !selfSignupToken
    })

    if (loading) {
      return <Spinner />
    }

    if (!secretLinkData?.organisation?.secretSelfSignupLink) {
      return (
        <PageWithSingleAlert
          title={t`This signup link is not valid anymore, please contact your LMS admin.`}
        />
      )
    }

    return (
      <>
        <HeadTitle title={t`Sign in`} />
        <WithSelfSignupContext data={secretLinkData}>
          <SelfSignupFormFieldsContext.Provider value={fieldsContext}>
            <SignupWithSecretLinkController submit={submit}>
              {(onFormSubmit, signupLoading) => (
                <WithSelfSignupFormik onSubmit={onFormSubmit}>
                  <SelfSignUpForm signupLoading={signupLoading} />
                </WithSelfSignupFormik>
              )}
            </SignupWithSecretLinkController>
          </SelfSignupFormFieldsContext.Provider>
        </WithSelfSignupContext>
      </>
    )
  })
SelfSignupWithSecretLink.displayName = 'SelfSignupWithSecretLink'
